import { useTranslation } from 'react-i18next';
import { gray } from 'theme/colors';
import { Divider, MenuItem, MenuList, Popover, Typography } from '@mui/material';
import { IconUserCircle, IconLogout } from '@tabler/icons-react';
import { useUser } from '@hooks';
import { useCompanyStore } from '@stores';
import ClientCompaniesList from './ClientCompaniesList';
import styles from './styles';

interface AccountPopoverProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  open: boolean;
}

/**
 * @description AccountPopover component.
 */
const AccountPopover = ({ anchorEl, onClose, open }: AccountPopoverProps) => {
  const { logout, user } = useUser();
  const { t } = useTranslation();
  const { setSelectedCompany } = useCompanyStore();

  /**
   * @function handleSignOut
   * @description Handle sign out action.
   */
  const handleSignOut = () => {
    logout();
    setSelectedCompany(null);
  };

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
      onClose={onClose}
      open={open}
      PaperProps={styles.paperProps}
    >
      <MenuList sx={styles.menuList}>
        <MenuItem disabled>
          <IconUserCircle size={'1.25rem'} color={gray[90]} />
          <Typography variant='body1'>{t('MENU:MY_ACCOUNT')}</Typography>
        </MenuItem>
        {!user?.isInternal && [<Divider key={0} />, <ClientCompaniesList key={1} />]}
        <Divider />
        <MenuItem onClick={handleSignOut}>
          <IconLogout size={'1.25rem'} color={gray[90]} />
          <Typography variant='body1'>{t('MENU:SIGN_OUT')}</Typography>{' '}
        </MenuItem>
      </MenuList>
    </Popover>
  );
};

export default AccountPopover;
